import { OrderReceiveMethod } from '@apis/type/order_receive_method_pb'

const Delivery = 'Delivery' as const
const Pickup = 'Pickup' as const
const None = 'None' as const

export const OrderReceiveKindTypes = {
  Delivery,
  Pickup,
  None,
} as const

export type OrderReceiveKindType =
  (typeof OrderReceiveKindTypes)[keyof typeof OrderReceiveKindTypes]

export const getOrderReceiveKindTypeFromMethod = (
  method: OrderReceiveMethod | undefined,
): OrderReceiveKindType => {
  if (!method) {
    return None
  }
  if (method.hasDelivery()) {
    return Delivery
  }
  if (method.hasPickup()) {
    return Pickup
  }
  return None
}
